import React from 'react';
import { Link } from 'react-router-dom';

export const About = () => (
  <div className="about">
    <h2>About us</h2>
    <Link to="/">Go back home</Link>
  </div>
);

export default About;
